import { c, classy, m } from '@onfido/castor';
import React from 'react';
export const Button = ({ kind = 'action', variant = 'primary', className, ...restProps }) => {
    const Element = 'href' in restProps ? 'a' : 'button';
    return (React.createElement(Element, Object.assign({}, restProps, (Element === 'a' && { role: 'button' }), { className: classy(c('button'), m(`${kind}--${variant}`), className) })));
};
//# sourceMappingURL=button.js.map